import { Card, CardHeader } from "@capacit-com/lara-law-shared-ui";
import { Skeleton } from "@capacit-com/lara-law-shared-ui";

const UserConversationSkeleton = () => {
  return (
    <>
      <Card className="rounded-lg shadow-md border-none">
        <div className="space-y-4 ">
          <div className="flex justify-between items-center px-4 pt-3">
            <Skeleton className="h-7 w-1/3 rounded-full" />
            <Skeleton className="h-8 w-1/3" />
          </div>

          <div className="flex border-t">
            <div className="space-y-2 px-4 w-1/2 border-r py-4">
              <Skeleton className="h-4 w-2/4" />
              <Skeleton className="h-6 w-1/6" />
            </div>
            <div className="space-y-2 px-4 w-1/2 py-4">
              <Skeleton className="h-4 w-2/4" />
              <Skeleton className="h-6 w-1/6" />
            </div>
          </div>
        </div>
      </Card>

      <Card className="p-4 rounded-lg shadow-md border-none">
        <CardHeader className="p-0 pb-2 border-b">
          <Skeleton className="h-6 w-24" />
        </CardHeader>
        <div className="space-y-4 py-4">
          {[...Array(5)].map((_, index) => (
            <div
              key={index}
              className={`flex gap-4 ${
                index % 2 === 1 ? "flex-row-reverse" : ""
              }`}
            >
              <Skeleton className="size-12 rounded-full shrink-0" />
              <div
                className={`flex flex-col space-y-2 flex-1 max-w-[80%] p-4 rounded-lg bg-accent-foreground/10 ${
                  index % 2 === 1 ? "items-end" : ""
                }`}
              >
                <Skeleton
                  className={`size-4/4 h-5 ${index % 2 === 1 ? "ml-auto" : ""}`}
                />
                <Skeleton
                  className={`h-5 w-2/3 ${index % 2 === 1 ? "ml-auto" : ""}`}
                />
              </div>
            </div>
          ))}
        </div>
      </Card>

      <Card className="p-6 rounded-lg shadow-md border-none">
        <div className="space-y-4">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-[200px] w-full" />
        </div>
      </Card>
    </>
  );
};

export default UserConversationSkeleton;
